import React from "react";

// Warli-style running figure motif — a single SVG line decoration
export const WarliDivider = ({ className = "" }) => (
  <svg
    viewBox="0 0 600 60"
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <line x1="0" y1="40" x2="600" y2="40" />
    {Array.from({ length: 10 }).map((_, i) => {
      const x = 30 + i * 60;
      return (
        <g key={i} transform={`translate(${x},10)`}>
          <circle cx="0" cy="6" r="4" fill="currentColor" />
          <line x1="0" y1="10" x2="0" y2="22" />
          <line x1="-8" y1="16" x2="8" y2="14" />
          <line x1="0" y1="22" x2="-7" y2="30" />
          <line x1="0" y1="22" x2="7" y2="30" />
        </g>
      );
    })}
  </svg>
);

// Kolam dot grid — used as faint background
export const KolamGrid = ({ className = "", cols = 9, rows = 9 }) => {
  const dots = [];
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      dots.push(<circle key={`${r}-${c}`} cx={20 + c * 32} cy={20 + r * 32} r="1.6" />);
    }
  }
  return (
    <svg
      viewBox={`0 0 ${cols * 32 + 8} ${rows * 32 + 8}`}
      className={className}
      fill="currentColor"
      aria-hidden="true"
    >
      {dots}
    </svg>
  );
};

// Kolam loop pattern — decorative single-stroke ornament
export const KolamLoop = ({ className = "" }) => (
  <svg viewBox="0 0 120 120" className={className} fill="none" stroke="currentColor" strokeWidth="1.2" aria-hidden="true">
    <circle cx="60" cy="60" r="46" />
    <path d="M60 14 C90 30, 90 90, 60 106 C30 90, 30 30, 60 14 Z" />
    <path d="M14 60 C30 30, 90 30, 106 60 C90 90, 30 90, 14 60 Z" />
    <circle cx="60" cy="60" r="3" fill="currentColor" />
  </svg>
);

// Section overline ribbon
export const Overline = ({ children, className = "" }) => (
  <span className={`overline ${className}`}>{children}</span>
);
